import React, { useEffect, useState } from 'react';
import { Badge } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FaChartBar } from 'react-icons/fa';
import api from '../../../api/apiClient';

const InstructorAssessmentList = () => {
  const navigate = useNavigate();
  const [assessments, setAssessments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAssessments = async () => {
      try {
        setLoading(true);
        const response = await api.assessments.getOrgAssessments();
        setAssessments(response.data?.data || []);
      } catch (error) {
        toast.error(error.response?.data?.message || 'Failed to load assessments');
        setAssessments([]);
      } finally {
        setLoading(false);
      }
    };
    fetchAssessments();
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center py-8">
        <div className="animate-spin rounded-full h-10 w-10 border-4 border-purple-600 border-t-transparent" />
      </div>
    );
  }

  return (
    <div className="p-4 bg-gradient-to-br from-purple-50 via-pink-50 to-blue-50 min-h-screen">
      <div className="mb-4">
        <h5 className="mb-1 text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-pink-600">
          Assessments
        </h5>
        <p className="text-sm text-gray-600 mb-0">
          View organization assessments, enrolled learners, and progress analytics.
        </p>
      </div>

      <div className="overflow-x-auto rounded-xl shadow-lg bg-white">
        <table className="table table-bordered table-hover mb-0">
          <thead className="bg-gradient-to-r from-purple-600 to-pink-600 text-white">
            <tr>
              <th>Title</th>
              <th>Duration</th>
              <th>Pass %</th>
              <th>Enrolled</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {assessments.length === 0 ? (
              <tr>
                <td colSpan={5} className="text-center text-muted py-4">
                  No assessments enrolled for your organization yet.
                </td>
              </tr>
            ) : (
              assessments.map((assessment) => (
                <tr key={assessment.id}>
                  <td className="font-medium">{assessment.title}</td>
                  <td>{assessment.duration_minutes} min</td>
                  <td>{assessment.pass_percentage}%</td>
                  <td>
                    <Badge bg="success">{assessment.enrolled_count || 0}</Badge>
                  </td>
                  <td>
                    <button
                      type="button"
                      onClick={() => navigate(`/instructor/assessments/${assessment.id}/analytics`)}
                      className="inline-flex items-center gap-1 px-3 py-1.5 text-xs font-semibold text-indigo-700 bg-indigo-50 rounded-lg hover:bg-indigo-100"
                      aria-label={`View analytics for ${assessment.title}`}
                    >
                      <FaChartBar /> Analytics
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default InstructorAssessmentList;
